import React, { useMemo } from "react";
import { Calendar as Component } from "primereact/calendar";

interface ICalendarProps {
  name: string;
  values?: any;
  errors?: any;
  touches: any;
  onBlur?: any;
  onChange: any;
  placeholder: any;
  label?: string;
  disabled?: any;
  minDate?: any;
  maxDate?: any;
  className?: any;
}

export const Calendar: React.FC<ICalendarProps> = ({
  name,
  values,
  errors,
  touches,
  onBlur,
  onChange,
  placeholder,
  label,
  disabled,
  minDate,
  maxDate,
  className,
}) => {
  const isInvalid = useMemo(() => {
    return touches[name] && !values[name] ? true : null;
  }, [touches, errors, name]);

  return (
    <div className="space-y-1 w-full relative">
      <label
        htmlFor={label}
        className="block text-[11px] font-bold text-Black"
      >
        {label}
      </label>
      <Component
        value={values[name] ? new Date(values[name]) : null}
        onChange={onChange}
        minDate={minDate}
        maxDate={maxDate}
        onBlur={onBlur}
        disabled={disabled}
        placeholder={placeholder}
        showIcon
        dateFormat="dd-mm-yy"
        id={name}
        inputId={name}
        className={
          className ? className : "p-2.5 rounded-md border w-full text-xs"
        }
      />

      {isInvalid ? (
        <div
          style={{ color: "#ef4444" }}
          className="font-bold text-[10px] mt-1 absolute"
        >
          {errors[name]}
        </div>
      ) : null}
    </div>
  );
};
